export default "__VITE_ASSET__BC8ZIl9f__"